// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_OpenAdvancesForPeriodResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /payroll/open_advances_for_period/{period_id}
 *
 * Returns the open/partial employee advances (manual + cash_recebimento)
 * for a payroll period, plus per-employee summary rollups, the running
 * total of remaining amounts, available cash recebimentos that can still
 * be converted into advances, and the items already selected for the
 * period (used by the wizard to resume editing).
 *
 * @see Payroll::open_advances_for_period() controller
 * @see Employee_advances_model::getOpenForPeriod() source query
 */
import type { Payroll_OpenAdvancesForPeriodAdvanceRow } from './Payroll_OpenAdvancesForPeriodAdvanceRow'
import type { Payroll_OpenAdvancesForPeriodCashRecebimentoRow } from './Payroll_OpenAdvancesForPeriodCashRecebimentoRow'
import type { Payroll_OpenAdvancesForPeriodSelectedItemRow } from './Payroll_OpenAdvancesForPeriodSelectedItemRow'
import type { Payroll_OpenAdvancesForPeriodSummaryRow } from './Payroll_OpenAdvancesForPeriodSummaryRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Payroll_OpenAdvancesForPeriodResponseDados {
advances: Payroll_OpenAdvancesForPeriodAdvanceRow[]
summary_by_employee: Payroll_OpenAdvancesForPeriodSummaryRow[]
total_open: number
available_cash_recebimentos: Payroll_OpenAdvancesForPeriodCashRecebimentoRow[]
selected_items: Payroll_OpenAdvancesForPeriodSelectedItemRow[]
}

export type Payroll_OpenAdvancesForPeriodResponse = ApiResponse<Payroll_OpenAdvancesForPeriodResponseDados>;

registerResponseContract('Payroll_OpenAdvancesForPeriodResponse', {
  advances: {
    type: 'array',
    required: true,
    items: {
      id:                  { type: 'number',  required: true },
      employee_id:         { type: 'string',  required: true },
      franchise_id:        { type: 'number',  required: true },
      title:               { type: 'string',  required: true },
      description:         { type: 'string',  required: false },
      amount:              { type: 'string',  required: true },
      request_date:        { type: 'string',  required: true },
      status:              { type: 'number',  required: true },
      amount_paid:         { type: 'string',  required: true },
      despesa_id:          { type: 'number',  required: false },
      created_at:          { type: 'string',  required: true },
      created_by:          { type: 'string',  required: true },
      updated_at:          { type: 'string',  required: false },
      source_type:         { type: 'string',  required: true },
      recebimento_id:      { type: 'number',  required: false },
      origin_period_id:    { type: 'number',  required: false },
      cash_date:           { type: 'string',  required: false },
      cash_valor_centavos: { type: 'number',  required: false },
      cash_cliente_nome:   { type: 'string',  required: false },
      amount_remaining:    { type: 'number',  required: true },
      employee_name:       { type: 'string',  required: false },
      source_type_label:   { type: 'string',  required: true },
    },
  },
  summary_by_employee: {
    type: 'array',
    required: true,
    items: {
      employee_id:     { type: 'string',  required: true },
      employee_name:   { type: 'string',  required: false },
      advance_count:   { type: 'number',  required: true },
      total_remaining: { type: 'number',  required: true },
      manual_count:    { type: 'number',  required: true },
      cash_count:      { type: 'number',  required: true },
    },
  },
  total_open:                  { type: 'number',  required: true },
  available_cash_recebimentos: {
    type: 'array',
    required: true,
    items: {
      recebimento_id:                 { type: 'number',  required: true },
      recebimento_data:               { type: 'string',  required: false },
      recebimento_valor:              { type: 'number',  required: false },
      amount_reais:                   { type: 'string',  required: false },
      recebimento_forma_pagamento_id: { type: 'number',  required: false },
      forma_pagamento_nome:           { type: 'string',  required: true },
      compromisso_id:                 { type: 'number',  required: true },
      operador_user_id:               { type: 'string',  required: false },
      cliente_nome:                   { type: 'string',  required: false },
      operador_name:                  { type: 'string',  required: false },
    },
  },
  selected_items: {
    type: 'array',
    required: true,
    items: {
      advance_id:     { type: 'number',  required: true },
      amount:         { type: 'number',  required: true },
      title:          { type: 'string',  required: true },
      employee_id:    { type: 'string',  required: false },
      employee_name:  { type: 'string',  required: false },
      advance_amount: { type: 'number',  required: true },
    },
  },
})
